const data = {
	"body": "<path fill=\"currentColor\" d=\"M19 5H5a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V8a3 3 0 0 0-3-3ZM4 8a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v1H4Zm16 8a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-5h16Z\"/><path fill=\"currentColor\" d=\"M7 15h4a1 1 0 0 0 0-2H7a1 1 0 0 0 0 2Zm8 0h2a1 1 0 0 0 0-2h-2a1 1 0 0 0 0 2Z\"/>",
	"width": 24,
	"height": 24
};
exports.__esModule = true;
exports.default = data;
